import React, { useState,useEffect, useRef } from "react";
import { isHTML } from "../../../../../utils/helpers";
import {getAllCancellationReasons} from "../../../../../services/medium";
import { use } from "react";
import "./index.css";
import { toast } from "react-toastify";

export default function ReasonCancel({ deleteUser,cancelRequest, id, reasons,
  selectedReason,
  setSelectedReason }) {
  
  return (
    <div className="confirm-delete-wrapper cancelation-popup-show register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog padding-unset modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <h5 className="reason-form-heading">Select reason for the cancellation from the list:</h5>
             <div className="mb-3">
          
              {reasons.map((r) => (
                <div className="reason-form-check" key={r.id}>
                  <input
                    className="form-check reason-input"
                    type="radio"
                    name="cancellationReason"
                    id={`reason-${r.id}`}
                    value={r.id} // optional, for form usage
                    checked={selectedReason === r.id}
                    onChange={() => setSelectedReason(r.id)}
                  />
                  <label className="form-check-label reason-check-label" htmlFor={`reason-${r.id}`}>
                    {r.value}
                  </label>
                </div>
              ))}
            </div>
             
              <div className="confirm-btn-box cancelation-popup-box">
                <div
                  className="register-medium-confirnation model-close-btn"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  Cancel
                </div>
                <div
                  className="register-medium-confirnation"
                  
            
                 onClick={() => {
                    if (selectedReason) {
                      deleteUser(selectedReason);
                      const modal = document.getElementById(id);
                      if (modal) {
                        window.$(modal).modal('hide'); // Bootstrap jQuery modal
                      } // pass selectedReason if needed
                    } else {
                      
                       toast.error("Please select any reason.", {
                                 position: "top-center",
                               });
                    }
                  }}
                >
                  Confirm
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
